<template>

  <div class="comments">
    <div class="row xs-mb-30">
      <div class="col-xs-6">
        <h3 class="pull-left xs-m-0">Comments <span v-if="comments.length > 0" style="font-size:70%;">({{filteredComments.length}})</span></h3>
      </div>
      <div class="col-xs-6">
        <router-link v-if="!currentUser.loggedIn" :to="{name: 'login', query: { redirect: '/blog-article/' + articleId }}" class="btn btn-default pull-right"><i class="fas fa-sign-in-alt"></i> &nbsp; Login to comment</router-link>
      </div>
    </div>

    <div class="clearfix"></div>

    <div class="write" v-if="currentUser.loggedIn">
      <div class="input">
        <div class="avatar"><img src="/static/img/avatar.png" alt="Avatar"></div>
        <Editable  v-model="commentText" placeholder="Write a public comment..."></Editable>
      </div>
      <div class="buttons text-right">
        <button v-if="!status" class="btn btn-primary xs-ml-20" v-on:click="submit()" :disabled="!commentText"><i class="far fa-comment"></i> &nbsp; Submit</button>
        <button v-else class="btn btn-default xs-ml-20" disabled>Submitting...</button>
      </div>
    </div>

    <div v-if="filteredComments.length > 0">
      <BlogComment v-for="comment in filteredComments" :show-delete="showDelete"  :comment="comment" :blogArticleId="articleId"></BlogComment>
    </div>
    <div v-else class="xs-pt-30">
      There are no comments for this article.
    </div>
  </div>

</template>

<script>

  import { mapState, mapActions, mapGetters } from 'vuex';
  import BlogComment from './BlogComment'
  import Editable from '../shared/controls/Editable'
  import _ from 'underscore'



  export default {
    props: {
      comments: Array,
      articleId: Number,
      showDelete: Boolean
    },
    components: {
      BlogComment,
      Editable
    },

    created() {
    },

    methods: {
      submit() {
        if (this.commentText) {
          this.status = 'Submitting...';
          const create = {
            comment: {
              blog_id: this.articleId,
              body: this.commentText
            },
            callback: (comment) => {
              this.status = '';
              this.newComments.push(comment);
              Toast.success('Comment created');
            }
          }
          this.$store.dispatch('createComment', create);
        }
      },
    },

    computed: {
      ...mapState([
        'currentUser',
      ]),
      filteredComments() {
        const com = this.comments.concat(this.newComments);
        return _.sortBy(com, function (c) {
          let d = new Date(c.created_at);
          return d;
        }).reverse();
      },
    },

    data() {
      return {
        commentText: '',
        newComments: [],
        status:'',
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .write {margin-bottom:20px;}
  .write .input {position:relative; padding-left:50px;margin-bottom:10px;}
  .write .input .avatar { position:absolute;top:0px;left:0px;}
  .write .input .avatar img {width:32px;border-radius:16px;}
  .write .buttons .btn-cancel {background:#FFFFFF; }

</style>



// WEBPACK FOOTER //
// BlogCommentsList.vue?5c2e22f5